export default "/iconNotificationCancel.svg";